import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    salesChannelId: '92420e60-86b5-4d0b-af28-3d896571b019',
    countryCodes: ['AT'],
    locale: 'de-AT',
});
